import { Col, notification, Row } from "antd";
import React from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";

export function openNotificationWithIcon(type, message, description) {
  notification[type]({
    message: message,
    description: description,
  });
}

export const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

export const getDateRange = (date) => {
  const current = date._d.getDay() === 0 ? 7 : date._d.getDay();
  const firstDay = new Date(
    new Date(date).getTime() - (current - 1) * 24 * 60 * 60 * 1000,
  );
  const endDay = new Date(
    new Date(firstDay).getTime() + 6 * 24 * 60 * 60 * 1000,
  );
  return getDaysArray(firstDay, endDay);
};

export const DescriptionItem = ({ title, content }) => (
  <Row>
    <Col
      span={24}
      style={{ textAlign: "left", marginBottom: 10, marginTop: 10 }}
      className={"site-description-item-profile-label"}
    >
      {title}
    </Col>
    <Col
      span={24}
      style={{ textAlign: "left" }}
      className={"site-description-content"}
    >
      {content}
    </Col>
  </Row>
);

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const errorHandle = (err) => {
  let dataError;
  if (!err.data) {
    return;
  }
  if (err.status === 500) {
    dataError = "Dữ liệu có vấn đề, vui lòng kiểm tra lại";
  }
  if (err.status === 400) {
    dataError = err.data.error;
  }
  // const dataError = Object.entries(err.data).map(([key, value]) => <p>{value}</p>)
  openNotificationWithIcon("error", "Lỗi", dataError);
};

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const TranslateError = (text) => {
  console.log(text);
};

export function weekCount(year, month_number) {
  let firstOfMonth = new Date(year, month_number - 1, 1);
  let day = firstOfMonth.getDay() || 6;
  day = day === 1 ? 0 : day;
  if (day) {
    day--;
  }
  let diff = 7 - day;
  let lastOfMonth = new Date(year, month_number, 0);
  let lastDate = lastOfMonth.getDate();
  if (lastOfMonth.getDay() === 1) {
    diff--;
  }
  let result = Math.ceil((lastDate - diff) / 7);
  return result + 1;
}

export function generateArrWeekAndDays(year, month_number) {
  let firstOfMonth = new Date(year, month_number - 1, 1);
  let lastOfMonth = new Date(year, month_number, 0);
  let result = [];
  let objTemp = {};
  let resultTemp = [];
  let countWeek = 1;
  for (const i = firstOfMonth; i <= lastOfMonth; i.setDate(i.getDate() + 1)) {
    resultTemp.push(moment(new Date(i)));
    if (i.getDay() === 0) {
      objTemp.name = "Tuần " + countWeek.toString();
      objTemp.days = resultTemp;
      objTemp.id = countWeek - 1;
      result.push(objTemp);
      objTemp = {};
      resultTemp = [];
      countWeek += 1;
    }
    if (
      new Date(i).getTime() === new Date(lastOfMonth).getTime() &&
      i.getDay() !== 0
    ) {
      objTemp.name = "Tuần " + countWeek.toString();
      objTemp.days = resultTemp;
      objTemp.id = countWeek - 1;
      result.push(objTemp);
    }
  }

  return result;
}

export const getDaysArray = function (s, e) {
  for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    a.push(new Date(d));
  }
  return a;
};

export const getDaysArray_dmy = function (s, e) {
  for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    a.push(moment(d).format("YYYY-MM-DD"));
  }
  return a;
};

export const getFirstDayAndLastDayofMonth = (date) => {
  const firstDay = moment(
    new Date(date.getFullYear(), date.getMonth(), 1),
  ).format("YYYYMMDD");
  const endDay = moment(
    new Date(date.getFullYear(), date.getMonth() + 1, 0),
  ).format("YYYYMMDD");
  return [firstDay, endDay];
};

export const masterMenu = [
  {
    name: "Cá nhân",
    icon: "fa fa-user me-2",
    key: "canhan",
    data: [
      {
        name: "Bảng chấm công cá nhân",
        url: "/ca-nhan",
        key: "bcccn",
        requiredPermission: ["personalTimesheet_view"],
      },
      {
        name: "Đề nghị chấm công",
        url: "/ca-nhan/de-nghi-cham-cong",
        key: "dncc",
        requiredPermission: ["attendanceRequest_view"],
      },
      // {
      //   name: "Đăng ký làm từ xa",
      //   url: "/ca-nhan/dang-ky-lam-wfh",
      //   key: "ckwfh",
      //   requiredPermission: ["is_wfh_commit"],
      // },
      {
        name: "Thi ISMS",
        url: "/ca-nhan/thi-isms",
        key: "thiisms",
        requiredPermission: ["attendanceRequest_view"],
      },
      // {name:'Bảng tổng công tháng',url:'/ca-nhan/bang-tong-cong-thang',key:'btct',requiredPermission:['is_personal_timesheet']},
    ],
  },
  {
    name: "Quản lý",
    icon: "fa fa-book me-2",
    key: "quanly",
    data: [
      {
        name: "Bảng chấm công chi tiết",
        url: "/cham-cong/bang-cham-cong-chi-tiet",
        key: "ccbccct",
        requiredPermission: ["detailed_timesheet_view"],
      },
      {
        name: "Danh sách đề nghị",
        url: "/cham-cong/danh-sach-de-nghi",
        key: "ccdsdn",
        requiredPermission: [
          "attendanceRequest_view_xx",
          "attendanceRequest_view_pd",
        ],
      },
      // {
      //   name: "Đăng ký làm từ xa",
      //   url: "/cham-cong/dang-ky-lam-wfh",
      //   key: "ccckwfhol",
      //   requiredPermission: ["wfh_commit_view"],
      // },
      {
        name: "Lịch làm việc",
        key: "llv",
        requiredPermission: ["set_working_schedule_xx"],
        children: [
          {
            name: "Lịch hành chính",
            url: "/cham-cong/lich-lam-viec",
            key: "sxllv",
            requiredPermission: ["set_working_schedule_xx"],
          },
          {
            name: "Lịch tăng ca",
            url: "/cham-cong/overtime",
            key: "ccovertime",
            requiredPermission: ["overtime_view"],
          },
        ],
      },
      // {name:'Lịch lễ/tết',url:'/cham-cong/bang-cham-cong-le-tet',key:'ccbcclt',requiredPermission:['is_holiday_timesheet_xx','is_holiday_timesheet_pd']},
      {
        name: "Tổng hợp công",
        url: "/cham-cong/tong-hop-cong",
        key: "qlthc",
        requiredPermission: ["working_consolidation_view_ql"],
      },
      {
        name: "Bảng phép",
        url: "/cham-cong/ql-bang-phep",
        key: "ccbp",
        requiredPermission: ["is_leave_date_xx"],
      },
    ],
    requiredPermission: ["overtime_xx", "overtime_pd"],
  },
  {
    name: "Nhân sự",
    icon: "fa fa-anchor me-2",
    key: "nhansu",
    data: [
      {
        name: "Khai báo",
        key: "kb",
        requiredPermission: [
          "is_declare_holiday_ns",
          "is_declare_sumholiday_ns",
        ],
        children: [
          // {name:'Danh sách người dùng',url:'/cau-hinh/danh-sach-nguoi-dung',key:'dsnd',requiredPermission:['is_declare_employees_ns']},
          {
            name: "Danh sách ngày lễ",
            url: "/nhan-su/danh-sach-ngay-le",
            key: "dsnl",
            requiredPermission: ["is_declare_holiday_ns"],
          },
          {
            name: "Tổng hợp ngày nghỉ",
            url: "/nhan-su/total-ngay-nghi",
            key: "totalngaynghi",
            requiredPermission: ["is_declare_sumholiday_ns"],
          },
        ],
      },
      {
        name: "Danh sách đề nghị",
        url: "/nhan-su/danh-sach-de-nghi",
        key: "nsdsdn",
        requiredPermission: ["detailed_timesheet_ns"],
      },
      {
        name: "Bảng chấm công chi tiết",
        url: "/nhan-su/bang-cham-cong-chi-tiet",
        key: "nsbccct",
        requiredPermission: ["detailed_timesheet_ns"],
      },
      {
        name: "Tổng hợp tăng ca",
        key: "thtc",
        requiredPermission: ["overtime_ns"],
        children: [
          {
            name: "Tăng ca thường",
            url: "/nhan-su/overtime",
            key: "thtct",
            requiredPermission: ["overtime_ns"],
          },
          {
            name: "Tăng ca đặc biệt",
            url: "/nhan-su/overtime-special",
            key: "thtcs",
            requiredPermission: ["overtime_ns"],
          },
        ],
      },
      // {
      //   name: "Đăng ký làm từ xa",
      //   url: "/nhan-su/dang-ky-lam-wfh",
      //   key: "nsckwfhol",
      //   requiredPermission: ["is_wfh_commit_ns"],
      // },
      {
        name: "Bảng phép",
        url: "/nhan-su/bang-phep",
        key: "bangphep",
        requiredPermission: ["leave_dashboard_ns"],
      },
      {
        name: "Tổng hợp công",
        url: "/nhan-su/tong-hop-cong",
        key: "thc",
        requiredPermission: ["working_consolidation_ns"],
      },
      {
        name: "Chốt công",
        url: "/nhan-su/chot-cong",
        key: "chotcong",
        requiredPermission: ["working_final_view"],
      },
    ],
  },
  {
    name: "ISMS",
    icon: "fa fa-cog me-2",
    key: "isms",
    data: [
      {
        name: "Đợt thi",
        key: "dot_thi",
        requiredPermission: ["isms_hr", "is_admin"],
        children: [
          {
            name: "Tạo đợt thi",
            url: "/isms/exam",
            key: "dot_thi",
            requiredPermission: ["isms_hr", "is_admin"],
          },
          {
            name: "Kết quả thi",
            url: "/isms/result-exam",
            key: "result_exam",
            requiredPermission: ["isms_hr", "is_admin"],
          },
        ],
      },
      {
        name: "Nhóm thi",
        url: "/isms/group",
        key: "nhom_thi",
        requiredPermission: ["isms_hr", "is_admin"],
      },
      {
        name: "Đề thi",
        url: "/isms/question",
        key: "de_thi",
        requiredPermission: ["isms_hr", "is_admin"],
      },
      {
        name: "Tài liệu",
        url: "/isms/document",
        key: "tai_lieu",
        requiredPermission: ["isms_hr", "is_admin"],
      },
    ],
  },
  {
    name: "Cấu hình",
    icon: "fa fa-cog me-2",
    key: "cauhinh",
    data: [
      {
        name: "Cấu hình hệ thống",
        url: "/cau-hinh/cau-hinh-he-thong",
        key: "chht",
        requiredPermission: ["is_declare_employees_ns", "is_admin"],
      },
    ],
  },
];

export const validatePermission = (a, b) => {
  return a.filter((item) => b.includes(item)).length > 0 ? true : false;
};

export const isMatchTwoArray = (a, b) => {
  return a.filter((item) => b.includes(item)).length > 0 ? true : false;
};

export const generateMenu = (perm) => {
  let results = [];
  if (perm) {
    for (const i of masterMenu) {
      let objTemp = {};
      objTemp.isShow = false;
      objTemp.name = i.name;
      objTemp.key = i.key;
      objTemp.icon = i.icon;
      objTemp.data = i.data;
      for (const j of i.data) {
        if (validatePermission(j.requiredPermission, perm)) {
          objTemp.isShow = true;
        }
      }
      results.push(objTemp);
    }
  }
  return results;
};

export function getMinute(time_end, time_start, time_break) {
  if (time_break == null) {
    time_break = 0;
  }
  let currentDate = moment(new Date()).format("YYYYMMDD");
  let second =
    moment(currentDate + time_end, "YYYYMMDDHH:mm:ss")._d -
    moment(currentDate + time_start, "YYYYMMDDHH:mm:ss")._d;
  let minute = second / 60 / 1000 - parseInt(time_break);
  return minute;
}

export function capitalizeFirstWord(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function return_filter_team(data_curr_bp) {
  var filter_team = [];
  data_curr_bp.forEach((bp) => {
    bp.team.forEach((element) => {
      filter_team.push({
        idTeam: element.id,
        team: element.tenTeam,
        idBoPhan: element.bophan,
      });
    });
  });

  return filter_team;
}

export function toSlug(str) {
  // Chuyển hết sang chữ thường
  // str = str.toLowerCase();

  // xóa dấu
  str = str
    .normalize("NFD") // chuyển chuỗi sang unicode tổ hợp
    .replace(/[\u0300-\u036f]/g, ""); // xóa các ký tự dấu sau khi tách tổ hợp

  // Thay ký tự đĐ
  str = str.replace(/[đĐ]/g, "d");

  // Xóa ký tự đặc biệt
  // str = str.replace(/([^0-9a-z-\s])/g, '');

  // Xóa khoảng trắng
  str = str.replace(/(\s+)/g, "");

  // Xóa ký tự - liên tiếp
  str = str.replace(/-+/g, "-");

  // xóa phần dư - ở đầu & cuối
  str = str.replace(/^-+|-+$/g, "");

  // return
  return str;
}

export const CardDieuKhoan = () => {
  return (
    <div>
      <p>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <strong>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                Do yêu cầu công việc, tôi được cấp quyền làm việc từ xa, tôi cam
                kết thực hiện các điều sau:
              </span>
            </strong>
          </span>
        </span>
      </p>
      <ol style={{ listStyleType: "upper-roman" }}>
        <li style={{ textAlign: "justify" }}>
          <span style={{ fontSize: "11pt" }}>
            <span style={{ fontFamily: "Calibri,sans-serif" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                Hiểu rõ làm việc từ xa chỉ thay đổi địa điểm làm việc, nội dung
                công việc và các tài khoản liên quan đến công việc vẫn được các
                cấp quản lý, IT kiểm soát trong quá trình làm việc và có trách
                nhiệm báo cáo, giải trình đầy đủ thời gian làm việc, nội dung
                công việc khi có yêu cầu.
              </span>
            </span>
          </span>
        </li>
        <li style={{ textAlign: "justify" }}>
          <span style={{ fontSize: "11pt" }}>
            <span style={{ fontFamily: "Calibri,sans-serif" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                Chấp hành đúng các nội quy làm việc từ xa, làm việc tại nhà và
                tuân thủ Quy định về Bảo mật thông tin khi làm việc từ xa của
                công ty:
              </span>
            </span>
          </span>
        </li>
      </ol>
      <ol>
        <li style={{ textAlign: "justify" }}>
          <span style={{ fontSize: "11pt" }}>
            <span style={{ fontFamily: "Calibri,sans-serif" }}>
              <strong>
                <span style={{ fontSize: "12.0pt" }}>
                  <span style={{ fontFamily: '"Times New Roman",serif' }}>
                    Bảo quản tài sản, thiết bị do công ty cấp và tài sản cá nhân
                    (máy tính cá nhân tại nhà, các thiết bị di động, kết nối từ
                    xa, v.v...) đươc sử dụng để phục vụ mục đích công việc:
                  </span>
                </span>
              </strong>
            </span>
          </span>
        </li>
      </ol>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                1.1 Không cho mượn hoặc cho người khác như gia đình và bạn bè sử
                dụng máy tính, thiết bị đang sử dụng làm việc từ xa.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                1.2 Cất giữ cẩn thận khi không sử dụng để tránh làm mất, bị đánh
                cắp.
              </span>
            </span>
          </span>
        </span>
      </p>
      <ol start={2}>
        <li style={{ textAlign: "justify" }}>
          <span style={{ fontSize: "11pt" }}>
            <span style={{ fontFamily: "Calibri,sans-serif" }}>
              <strong>
                <span style={{ fontSize: "12.0pt" }}>
                  <span style={{ fontFamily: '"Times New Roman",serif' }}>
                    Đối phó mã độc và truy cập bên ngoài:
                  </span>
                </span>
              </strong>
            </span>
          </span>
        </li>
      </ol>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.1 Tuân thủ hướng dẫn của Bộ phận IT về việc cài đặt, sử dụng
                các thiết bị di động, kết nối từ xa tới hệ thống thông tin của
                Công ty.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.2 Máy tính và các thiết bị di động phải được cài đặt và cập
                nhật phần mềm chống virus phiên bản mới nhất và thực hiện quét
                virus định kỳ 1 tuần/lần.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.3 Không tải xuống, cài đặt hoặc sử dụng phần mềm không được
                phép sử dụng, không có bản quyền.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.4 Tuyệt đối không được tải lên hoặc lưu trữ thông tin bảo mật
                của Công ty trên website, ổ lưu trữ internet công cộng hay cá
                nhân.
              </span>
            </span>
          </span>
        </span>
      </p>
      {/* <p>
        <span style={{ fontSize: "12.0pt" }}>
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            2.4 Tuyệt đối không được tải lên hoặc lưu trữ thông tin bảo mật của
            Công ty trên website, ổ lưu trữ internet công cộng hay cá nhân.
          </span>
        </span>
      </p> */}
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.5 Không kết nối tới các wifi công cộng, wifi mà mình không
                biết.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.6 Không chia sẻ mật khẩu với bất cứ ai, kể cả người trong gia
                đình, bạn bè và nhân viên IT.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                2.7 Không mở tập tin, vào các đường dẫn (link) của các email lạ
                hoặc tin nhắn rác.
              </span>
            </span>
          </span>
        </span>
      </p>
      <ol start={3}>
        <li style={{ textAlign: "justify" }}>
          <span style={{ fontSize: "11pt" }}>
            <span style={{ fontFamily: "Calibri,sans-serif" }}>
              <strong>
                <span style={{ fontSize: "12.0pt" }}>
                  <span style={{ fontFamily: '"Times New Roman",serif' }}>
                    Đối ứng khi có sự cố:
                  </span>
                </span>
              </strong>
            </span>
          </span>
        </li>
      </ol>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                3.1 Báo cáo ngay cho Cán bộ quản lý cấp trên và ban ISMS khi
                phát hiện có hiện tượng nghi ngờ hoặc sự cố BMTT chậm nhất trong
                vòng 2 giờ để tìm phương hướng giải quyết.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "48px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                <span style={{ width: "90px", display: "inline-block" }}>
                  Email:
                </span>
                <span style={{ color: "blue" }}>
                  <a
                    href="mailto:isms@rainscales.com.vn"
                    style={{ color: "blue", textDecoration: "underline" }}
                  >
                    isms@rainscales.com.vn
                  </a>
                </span>
                ;
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "48px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                <span style={{ width: "90px", display: "inline-block" }}>
                  Hotline:
                </span>
                Nguyễn Phúc Huyền Anh (Ban IT) - Số ĐT: 0905 626 313
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "48px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                <span style={{ width: "90px", display: "inline-block" }}></span>
                Nguyễn Hoàng Ly (Trưởng Nhóm ISMS) - Số ĐT: 0905 804 585
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ marginLeft: "24px", textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: "Calibri,sans-serif" }}>
            <span style={{ fontSize: "12.0pt" }}>
              <span style={{ fontFamily: '"Times New Roman",serif' }}>
                3.2 Hợp tác xử lý sự cố về bảo mật thông tin khi được Công ty
                hoặc khách hàng yêu cầu.
              </span>
            </span>
          </span>
        </span>
      </p>
      <p style={{ textAlign: "justify" }}>
        <span style={{ fontSize: "11pt" }}>
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            Nếu không thực hiện các cam kết nêu trên, tôi xin chịu hoàn toàn
            trách nhiệm và các hình thức xử lý theo quy chế, nội quy của Công
            ty.
          </span>
        </span>
      </p>
    </div>
  );
};

export function isMobile() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(
    navigator.userAgent || navigator.vendor,
    // || window.opera
  );
  return check;
}

export const useViewport = () => {
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return { width };

  // ==> const viewPort = useViewport();
  // const isMobile = viewPort.width <= 1024;
  // if (isMobile) {
  //   return <h1>Mobile layout</h1>
  // }
  // return (
  //   <h1>Desktop layout</h1>
  // );
};
